import React, { useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import { Drawer } from "../../Components/Organisms";
import "./styles.css";
import { HamburgerMenuIcon } from "../../Assets/images/svgs";
import { AuthContext } from "../../Library/contexts";


const Panel = ({ user, codes }) => {
  const [ showDrawer, setShowDrawer ] = useState(false);
  const { assets } = useContext(AuthContext);

  const hideDrawer = () => {
    setShowDrawer(false);
  }

  return (
    <main className="panel-body">
      <div className="drawer-menu-icon">
        <HamburgerMenuIcon className="ham-icon" onClick={() => setShowDrawer(true)} />
        <img alt="logo" src={assets.assetUrl + "/" + assets.logo} />
      </div>
      <Drawer user={user} showDrawer={showDrawer} hideDrawer={hideDrawer} codes={codes} />
      <Outlet />
    </main>
  );
};

export default Panel;
